/* tslint:disable:max-line-length */
import gql from 'graphql-tag';

export const DeleteArticles = gql`
  mutation DeleteArticles($ids: [ID!]!) {
    deleteArticles(ids: $ids)
  }
`;
